import * as React from 'react';
import { DateFormatters } from 'app/infrastructure/data/types';
import { objectOfType } from 'app/infrastructure/data/object';
import { FavouriteItem } from 'app/area/favourite-administration/form/types-store';
import { FavouriteAdminTranslation } from 'app/area/favourite-administration/constants';
import style from './report-panel.scss';

interface OriginPanelProps {
  data: FavouriteItem;
  formatters: DateFormatters;
  translation: FavouriteAdminTranslation;
}

const ReportPanelComponent = (props: OriginPanelProps) => {
  const { data = objectOfType<FavouriteItem>(),
    formatters,
    translation } = props;

  const dateFormatter = (date: Date) => formatters.formatDate(date, {
    day: 'numeric',
    month: 'numeric',
    year: 'numeric'
  });

  const showCreatedData = data.created || data.createdBy?.description && data.createdBy?.value > 0;
  const showModifiedData = data.modified || data.modifiedBy?.description && data.modifiedBy?.value > 0;

  const created = data.created ? ` ${dateFormatter(data.created)}` : '';
  const createdBy = data.createdBy?.value > 0 && data.createdBy?.description ? ` ${translation.by}` : '';
  const createdByFavourite = data.createdBy?.value > 0 && data.createdBy?.description ? ` ${data.createdBy.description}` : '';

  const modified = data.modified ? ` ${dateFormatter(data.modified)}` : '';
  const modifiedBy = data.modifiedBy?.value > 0 && data.modifiedBy?.description ? ` ${translation.by}` : '';
  const modifiedByFavourite = data.modifiedBy?.value > 0 && data.modifiedBy?.description ? ` ${data.modifiedBy.description}` : '';

  return (<div className="row justify-content-between">
    <div className="col col-auto">
      <div className={style.dateContainer}>
        <ul className={`${style.date} ${!data.reportType.description && style.separator}`}>
          {showCreatedData && <li>{translation.created}<span className={style.bold}>{created}</span>
            {createdBy}<span className={style.bold}>{createdByFavourite}</span></li>}
          {showModifiedData && <li>{translation.modified}<span className={style.bold}>{modified}</span>
            {modifiedBy}<span className={style.bold}>{modifiedByFavourite}</span></li>}
        </ul>
      </div>
      <span className={style.description}>{data.reportType.description}{data.reportName ? ` | ${data.reportName}` : null}</span>
    </div>
  </div>);
};

export const ReportPanel = ReportPanelComponent;
